import { GetAllProductionPlanningNumber, GetMonthlyPurchase, GetMonthlySales, GetMonthlySalesAndPurchase, GetTopActiveClients, GetTopSellingProducts } from "../ApiEndPoints.js";
import { axiosGetWithencryption, axiosPostWithencryption } from "../AxiosRequests.js";

export default class DashboardServices {
    async getAllProductionPlanningNumber(request) {
        return axiosGetWithencryption(GetAllProductionPlanningNumber, request);
    }
    async getTopSellingProducts(request) {
        return axiosGetWithencryption(GetTopSellingProducts, request);
    }
    async getTopActiveClients(request) {
        return axiosGetWithencryption(GetTopActiveClients, request);
    }
    async getMonthlySalesAndPurchase(request) {
        return axiosGetWithencryption(GetMonthlySalesAndPurchase, request);
    }
}